import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import organizationService from '../../../services/organization/organizationService';

/**
 * The brand at the header's leading edge, drawn while the sidebar is the
 * collapsed rail. The rail is 80px, room for the "S" mark only, so without
 * this the full wordmark — and a white-label organization's own logo — had
 * nowhere to show in the default layout. The expanded sidebar draws both
 * itself, so AppLayout shows this only when the sidebar is collapsed.
 *
 * Organization logo when the org has one ("powered by saf3ai" beside it, as
 * in the expanded sidebar); the SAF3AI wordmark otherwise, or when the image
 * fails to load.
 */
export default function HeaderBrand() {
  const { t } = useTranslation('layout');
  const [logoUrl, setLogoUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let live = true;
    const load = () => {
      organizationService.getCurrentOrganizationLogo()
        .then((url) => {
          if (!live) return;
          setLogoUrl(url || null);
          setFailed(false);
        })
        .catch(() => {});
    };
    load();
    // Another tab signing in as someone else changes the organization.
    const onStorage = (e) => { if (e.key === 'user') load(); };
    window.addEventListener('storage', onStorage);
    return () => {
      live = false;
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  if (logoUrl && !failed) {
    return (
      <div className="header-brand" data-testid="header-brand">
        <img
          src={logoUrl}
          alt={t('layout:sidebarSidebar.organizationLogo')}
          className="header-brand-org"
          onError={() => setFailed(true)}
        />
        <span className="header-brand-powered">
          {t('layout:sidebarSidebar.poweredBy')}{' '}
          <span className="header-brand-saf">
            {t('layout:sidebarSidebar.brandSaf')}3<span className="header-brand-accent">{t('layout:sidebarSidebar.ai2')}</span>
          </span>
        </span>
      </div>
    );
  }

  return (
    <div className="header-brand" data-testid="header-brand">
      <span className="header-brand-wordmark">
        SAF<span className="header-brand-three">3</span><span className="header-brand-accent">{t('layout:sidebarSidebar.ai')}</span>
      </span>
    </div>
  );
}
